import React from "react"
import { TutorialContentTableRow } from "./TutorialContentSequenceRow"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { StructuredSequence } from "../../../../../../../../../Hooks/useStructuredTrainingQuestionTutorial"

interface TutorialContentSequenceProps {
    sequence: StructuredSequence[]
    onMoveItem: (dragIndex: number, hoverIndex: number) => void
    onEndMove: (id: string) => void
    onDelete: (id: string) => void
    onEdit: (item: StructuredSequence) => void
}

export const TutorialContentSequence = ({
    sequence,
    onMoveItem,
    onEndMove,
    onDelete,
    onEdit
}: TutorialContentSequenceProps) => {
    const headerCommonClassName =
        "text-smoke-610 h-full z-10 p-2 align-bottom text-left font-normal bg-rhino-100 border-0 border-b border-solid border-rhino-300 sticky top-0 left-0"
    return (
        <table
            className="w-full h-0 min-h-0 mt-0 border-separate table-fixed"
            style={{ borderSpacing: 0 }}
        >
            <thead>
                <tr className="bg-rhino-100 border-0 border-b border-solid border-rhino-300">
                    <th className={`${headerCommonClassName} w-1/12`} />
                    <th
                        key="step"
                        className={`${headerCommonClassName} w-2/12`}
                    >
                        Step
                    </th>
                    <th
                        key="type"
                        className={`${headerCommonClassName} w-2/12`}
                    >
                        Type
                    </th>
                    <th
                        key="summary"
                        className={`${headerCommonClassName} w-6/12`}
                    >
                        Summary
                    </th>
                    <th
                        key="action"
                        className={`${headerCommonClassName}`}
                    ></th>
                </tr>
            </thead>
            <tbody>
                <DndProvider backend={HTML5Backend}>
                    {sequence.map((item, index) => (
                        <TutorialContentTableRow
                            key={item.id}
                            index={index}
                            sequence={item}
                            onMoveItem={onMoveItem}
                            onEndMove={onEndMove}
                            onDelete={onDelete}
                            onEdit={onEdit}
                        />
                    ))}
                </DndProvider>
            </tbody>
        </table>
    )
}
